import React from 'react';
import moment from 'moment';
import PropTypes from 'prop-types';
import { StyleSheet } from 'aphrodite';

import OurismanTravelTheme from '../../ourismanTravelTheme';

const NoteListItem = ({ note }) => {
  const { content, owner: { firstName }, created, segmentName } = note;
  const timestamp = moment(created).format('dddd, MMMM Do YYYY, h:mm a');
  const fromNow = moment(created).fromNow();

  return (<li className={newCss(styles.noteList)}>
    <div className={newCss(styles.noteMeta)}>
      <span className={newCss(styles.noteUser)}>{firstName}</span>
      <span className={newCss(styles.noteTimestamp)}>{timestamp}</span>
      <span className={newCss(styles.noteFromNow)}>({fromNow})</span>
    </div>
    {segmentName !== undefined ? <div>
      Segment note for <b>{segmentName}</b>:
    </div> : null }
    {/* eslint-disable react/no-danger */}
    <div
      className='ql-editor'
      dangerouslySetInnerHTML={{ __html: content }}
    />
    {/* eslint-enable react/no-danger */}
  </li>);
};
NoteListItem.propTypes = {
  note: PropTypes.shape().isRequired,
};

export default NoteListItem;

const globalSelectorHandler = (selector, _, generateSubtreeStyles) => {
  if (selector[0] !== '*') {
    return null;
  }

  return generateSubtreeStyles(selector.slice(1));
};
const globalExtension = { selectorHandler: globalSelectorHandler };
const { StyleSheet: newStyleSheet, css: newCss } = StyleSheet.extend([globalExtension]);

const styles = newStyleSheet.create({
  noteList: {
    display: 'flex',
    flexDirection: 'column',
    marginBottom: 5,
    ':nth-child(even)': {
      background: OurismanTravelTheme.palette.primary3Color,
    },
  },
  noteMeta: {
    display: 'flex',
    alignItems: 'baseline',
    borderBottom: `1px solid ${OurismanTravelTheme.palette.borderColor}`,
  },
  noteUser: {
    paddingRight: 5,
    fontWeight: 'bold',
    fontSize: 12,
  },
  noteTimestamp: {
    color: OurismanTravelTheme.palette.accent1Color,
    paddingRight: 5,
    fontSize: 10,
  },
  noteFromNow: {
    color: OurismanTravelTheme.palette.accent1Color,
    fontSize: 10,
  },
  noteContent: {
    whiteSpace: 'pre-wrap',
  },
});



// WEBPACK FOOTER //
// /src/components/Trips/NoteListItem.js